import { APP_DOMAIN } from 'services/constants';

/** Auth cookies that must survive navigation between company subdomains on the same web app. */
export const SHARED_AUTH_COOKIE_NAMES = new Set(['token', 'impersonate']);

/** Host-only cookies on bare loopback — not on company subdomains under APP_DOMAIN. */
const isBareLoopbackHost = hostname => hostname === 'localhost' || hostname === '127.0.0.1';

/**
 * Shared cookie domain for the web app (e.g. `.web.ommnio.com`, `.dev.ommnio.localhost`).
 * Host-only on bare localhost / 127.0.0.1; scoped to APP_DOMAIN for company subdomains.
 */
export const getSharedCookieDomain = (
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
) => {
  if (!APP_DOMAIN || !hostname || isBareLoopbackHost(hostname)) {
    return undefined;
  }
  if (hostname === APP_DOMAIN || hostname.endsWith(`.${APP_DOMAIN}`)) {
    return `.${APP_DOMAIN}`;
  }
  return undefined;
};

export const getCookieDomainForName = (name, hostname) => {
  if (SHARED_AUTH_COOKIE_NAMES.has(name)) {
    return getSharedCookieDomain(hostname);
  }
  return undefined;
};

export const getCookieSecureDefault = (
  protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:',
) => protocol === 'https:';

/** Host-only and shared-domain scopes used while migrating off legacy `.ommnio.com` cookies. */
export const getAuthCookieRemovalTargets = (name, hostname) => {
  if (!SHARED_AUTH_COOKIE_NAMES.has(name)) {
    return [{ path: '/' }];
  }
  const sharedDomain = getCookieDomainForName(name, hostname);
  const targets = [{ path: '/' }];
  if (sharedDomain) {
    targets.push({ path: '/', domain: sharedDomain });
  }
  return targets;
};
